<template>
  <a-modal
    width="800px"
    title="图像查看"
    v-model:visible="visible"
    :footer="false"
  >
    <a-carousel arrows>
      <template v-slot:prevArrow>
        <div class="custom-slick-arrow" style="left: 10px;zIndex: 3">
          <left-circle-outlined />
        </div>
      </template>
      <template v-slot:nextArrow>
        <div class="custom-slick-arrow" style="right: 10px;zIndex: 3">
          <right-circle-outlined />
        </div>
      </template>
      <div class="dialog-pic" v-for="(item, index) in list" :key="index">
        <img :src="appConfig.baseImgUrl + item.accessSrc" alt="">
      </div>
    </a-carousel>
  </a-modal>

</template>
<script>
import { mapState } from 'vuex'
import { LeftCircleOutlined, RightCircleOutlined } from '@ant-design/icons-vue'
export default {
  props: {
    list: {
      type: Array,
      default: () => []
    }
  },
  components: {
    LeftCircleOutlined,
    RightCircleOutlined
  },
  data () {
    return {
      visible: false
    }
  },
  computed: {
    ...mapState(['appConfig'])
  },
  methods: {
    open () {
      this.visible = true
    }
  }
}
</script>
<style lang="less">
  .ant-carousel .slick-slide {
    text-align: center;
    overflow: hidden;
  }

  .ant-carousel .slick-arrow.custom-slick-arrow {
    width: 25px;
    height: 25px;
    font-size: 25px;
    color: #999;
  }
  .ant-carousel .custom-slick-arrow:before {
    display: none;
  }
  .ant-carousel .custom-slick-arrow:hover {
    opacity: 0.5;
  }

  .dialog-pic {
    width: 100%; height: 400px;
    background: #ccc;
    text-align: center;
    img {
      margin: 0 auto;
      width: auto; height: 100%;
      background: #ccc;
    }
  }
</style>
